import Client from 'shopify-buy'

let client = null

export const getShopifyClient = () => {
  if (client === null && process.env.VUE_APP_SHOPIFY_TOKEN) {
    client = Client.buildClient({
      domain: process.env.VUE_APP_SHOPIFY_DOMAIN,
      storefrontAccessToken: process.env.VUE_APP_SHOPIFY_TOKEN
    })
  }

  return client
}
